import { Checkbox, Col, Row } from "antd";
import SelectValue from "../Selector/SelectValue";
import TranslateText from "../TranslateText";
import "../../../assets/style/featuresStyle/menuConfig.scss";
import BaseButton from "../Button/BaseButton";
import { IconPlus } from "../../../assets/icon";
import { useEffect, useMemo, useState } from "react";
import {
  deleteTabMenu,
  getALLMenu,
  getAllDisplay,
  setOpenAddTab,
  setValueSelect,
} from "../../../services/slice/ConfigMenuSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  configMenuSelector,
  pupSelector,
} from "../../../services/selector/index.";
import { useTranslation } from "react-i18next";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import ModalAddTabMenu from "../Modal/add/ModalAddTabMenu";
import ModalRightClickToMenu from "../Modal/other/ModalRightClickToMenu";
import ModalDelete from "../Modal/delete/ModalDelete";
import ModalEditTabMenu from "../Modal/edit/ModalEditTabMenu";

const ListMenu = ({ type, setType }) => {
  const configMenuState = useSelector(configMenuSelector);
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { t } = useTranslation();
  const [menuSelect, setMenuSelect] = useState([]);
  const [openDrop, setOpenDrop] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0, value: "" });
  const dispatch = useDispatch();
  const typeAdmin = useMemo(() => {
    let result = "";
    if (type) return (result = 1);
    // eslint-disable-next-line no-unused-vars
    return (result = 0);
  }, [type]);
  useEffect(() => {
    dispatch(getAllDisplay());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getALLMenu(typeAdmin));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeAdmin]);
  useEffect(() => {
    if (configMenuState.refetch) dispatch(getALLMenu(typeAdmin));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configMenuState.refetch]);
  const [checkList, setChecklist] = useState([]);
  const onChange = (checkedValues) => {
    let result = [];
    setChecklist(checkedValues);
    checkedValues.map((item) =>
      result.push({
        id: item.id,
        parent: 0,
        droppable: true,
        text: item.nameVn,
      })
    );
    setMenuSelect(result);
  };
  const valueOptionsRole = [
    {
      value: 0,
      label: t("Người dùng"),
    },

    {
      value: 1,
      label: t("Quản trị viên"),
    },
  ];
  const handleRightClick = (e, value) => {
    e.preventDefault();
    setOffset({
      x: e.clientX,
      y: e.clientY,
      value: value,
    });
    setOpenDrop(true);
  };
  const handleDelete = () => {
    dispatch(deleteTabMenu({ type: typeAdmin, id: offset.value.id }));
    dispatch(setOpenPUDelete({ stateOpen: false, content: "", id: "" }));
  };
  return (
    <>
      {configMenuState.isOpenAddTab && <ModalAddTabMenu type={typeAdmin} />}
      {openDrop ? (
        <ModalRightClickToMenu
          setOpen={setOpenDrop}
          top={offset.y}
          value={offset.value}
          right={offset.x}
        />
      ) : null}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa Tab"
          title="Xóa tab menu"
          width={680}
        />
      )}
      {configMenuState.isOpenModalEditTab ? (
        <ModalEditTabMenu type={typeAdmin} />
      ) : null}
      <div className="wrapperListMenu">
        <Row
          className="headerListMenu"
          justify={"space-between"}
          align="middle"
        >
          <Col xxl={12} xl={14} lg={11}>
            {" "}
            <span className="title">
              <TranslateText text={"Danh sách Menu"} />
            </span>
          </Col>
          <Col xxl={12} xl={10} lg={13}>
            <SelectValue
              type={"selectGray"}
              optionsValue={valueOptionsRole}
              defaultValue={t(valueOptionsRole[0].label)}
              width={150}
              handleChange={(value) => {
                setType(value);
              }}
              key="selectOptionRole"
            />
          </Col>
        </Row>
        <div className="wrapperCheckbox">
          <Checkbox.Group
            value={checkList}
            onChange={onChange}
            style={{ width: "100%", flexDirection: "column" }}
          >
            {configMenuState?.dataMenu?.map((item) => (
              <Row
                key={item.id}
                style={{ width: "100%", height: "100%" }}
                onContextMenu={(e) => handleRightClick(e, item)}
              >
                <Col span={24}>
                  <Checkbox value={item}>
                    <TranslateText text={item.nameVn} />
                  </Checkbox>
                </Col>
              </Row>
            ))}
          </Checkbox.Group>
          <Row
            onClick={() => dispatch(setOpenAddTab(true))}
            className="btnAddTab"
            align={"middle"}
            gutter={20}
          >
            <Col style={{ paddingLeft: "0.5rem" }}>
              <BaseButton
                styleBtn={{
                  width: 22,
                  height: 22,
                  backgroundColor: "#F66524",
                  border: "none",
                  padding: "0",
                }}
                typeBtn={"squareBtn"}
                content={<IconPlus />}
                width="100%"
              />
            </Col>
            <div className="textBtnAddTab">
              <span>
                <TranslateText text={"Thêm tab"} />
              </span>
            </div>
          </Row>
        </div>
        <Row align={"bottom"} style={{ flexGrow: 1 }}>
          <BaseButton
            width={170}
            styleBtn={{ height: "3.4rem" }}
            typeBtn="btnOrange"
            handleClick={() => {
              dispatch(setValueSelect(menuSelect));
              setChecklist([]);
              setMenuSelect([]);
            }}
            icon={<IconPlus />}
            content={`Thêm vào menu`}
          />
        </Row>
      </div>
    </>
  );
};

export default ListMenu;
